import { DataTestId } from '@mews-distributor/common';
import { LocalizedText } from '@mews/framework';
import { Stack, Title, Typography, WithChildren } from '@optimus-web/core';

export interface ViewHeadingProps extends WithChildren {
    pageTitleTextKey: Mews.TextKey;
    subtitle?: string | null;
    'data-test-id'?: DataTestId;
}

export const ViewHeading: React.FC<ViewHeadingProps> = ({
    pageTitleTextKey,
    subtitle,
    children,
    'data-test-id': dataTestId,
}) => (
    <Stack vertical spacing="100">
        <Title level={1} align="center" data-test-id={dataTestId}>
            <LocalizedText textKey={pageTitleTextKey} />
        </Title>
        {subtitle != null ? (
            <Typography textStyle="titleSmall" align="center" variant="secondary" as="div">
                {subtitle}
            </Typography>
        ) : null}
        {children}
    </Stack>
);
